<template>
  <v-container fluid v-if="hasAccessToPage" class="visitors-table-page">
    <v-row justify="center">
      <v-col cols="12" sm="12" md="12" lg="12" xl="10" class="pt-0">
        <TravelersTable />
      </v-col>
    </v-row>
  </v-container>
  <NoAccessMessage v-else />
</template>

<script>
import TravelersTable from '@/views/VisitorApprovalPage/components/TravelersTable.vue';
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import NoAccessMessage from '@/components/generic/no-access-message.vue';

export default {
  mixins: [SharedFunctions],
  components: {
    TravelersTable,
    NoAccessMessage
  },
  data() {
    return {
      hasAccessToPage: false
    };
  },
  created() {
    this.hasAccessToPage = this.hasAccessToPageMixin();
  }
};
</script>